var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.5,
    height: 15.783,
    viewBox: "0 0 39.5 15.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11285",
    "data-name": "Group 11285",
    transform: "translate(-873.25 -4134.13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1674",
    "data-name": "Ellipse 1674",
    className: "cls-1",
    cx: 3.107,
    cy: 3.108,
    rx: 3.107,
    ry: 3.108,
    transform: "translate(896.442 4138.265)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1675",
    "data-name": "Ellipse 1675",
    className: "cls-2",
    cx: 6.557,
    cy: 6.559,
    rx: 6.557,
    ry: 6.559,
    transform: "translate(893.058 4134.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4682",
    "data-name": "Path 4682",
    className: "cls-2",
    d: "M19.234,25.29H2.11A1.615,1.615,0,0,1,.5,23.679V15.411A1.615,1.615,0,0,1,2.11,13.8h17",
    transform: "translate(873.5 4121.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4683",
    "data-name": "Path 4683",
    className: "cls-2",
    d: "M229.431,13.8h4.184a1.615,1.615,0,0,1,1.61,1.611v8.268a1.615,1.615,0,0,1-1.61,1.611h-4.372",
    transform: "translate(676.775 4121.975)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1035",
    "data-name": "Line 1035",
    className: "cls-3",
    y2: 1.165,
    transform: "translate(878.186 4147.999)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1036",
    "data-name": "Line 1036",
    className: "cls-3",
    y2: 1.165,
    transform: "translate(908.109 4147.999)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1676",
    "data-name": "Ellipse 1676",
    className: "cls-2",
    cx: 1.047,
    cy: 1.047,
    rx: 1.047,
    ry: 1.047,
    transform: "translate(879.335 4140.527)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1677",
    "data-name": "Ellipse 1677",
    className: "cls-2",
    cx: 1.047,
    cy: 1.047,
    rx: 1.047,
    ry: 1.047,
    transform: "translate(884.515 4140.527)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjector);
export default __webpack_public_path__ + "static/media/projector.373547c30b0b16de49ebd591bc522be2.svg";
export { ForwardRef as ReactComponent };